import axios from 'axios';
import { loginreq, req } from './axiosFun';

var url = 'http://8.209.119.179:9899';
// var url = 'http://localhost:3000';
// 登录接口
export const login = (params) => { return loginreq("post", `${url}/posts?login=1`, params) };
// 获取用户菜单
export const menu = (params) => { return axios.post(`${url}/posts?getMenu=1`,params).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.post(`${url}/posts?loginout=` + JSON.parse(localStorage.getItem('userdata'))._id).then(res => res.data) };

/**
 * 用户管理
 **/
// 获取数据信息
export const userList = (params) => { return req("post", `${url}/posts?getData=1`, params) };
export const getUserData = (params) => { return req("post", `${url}/posts?user=1`, params) };
export const getPatientData = (params) => { return req("post", `${url}/posts?patient=1`, params) };
export const getMachineData = (params) => { return req("post", `${url}/posts?machine=1`, params) };
export const disableMachine = (params) => { return req("post", `${url}/posts?disableMachine=1`, params) };
export const getAlarmData = (params) => { return req("post", `${url}/posts?alarm=1`, params) };
export const getVersion = (params) => { return req("post", `${url}/posts?version=1`, params) };
export const getHistory = (params) => { return req("post", `${url}/posts?history=1`, params) };
export const getChat = (params) => { return req("post", `${url}/posts?chat=1`, params) };getRealTime
export const saveChat = (params) => { return req("post", `${url}/posts?saveChat=1`, params) };
export const getRealTime = (params) => { return req("post", `${url}/posts?realTime=1`, params) };
export const saveRealTime = (params) => { return req("post", `${url}/posts?saveRealTime=1`, params) };
export const getRole = (params) => { return req("post", `${url}/posts?role=1`, params) };
export const createPatient = (params) => { return req("post", `${url}/posts?createPatient=1`, params) };
export const createScheduledSession = (params) => { return req("post", `${url}/posts?createScheduledSession=1`, params) };
export const deletePatient = (params) => { return req("post", `${url}/posts?deletePatient=1`, params) };
export const editMachine = (params) => { return req("post", `${url}/posts?editMachine=1`, params) };
export const getTotal = (params) => { return req("post", `${url}/posts?getTotal=1`, params) };
export const saveUserTotal = (params) => { return req("post", `${url}/posts?saveUserTotal=1`, params) };
export const getbeautyCenter = (params) => { return req("post", `${url}/posts?getbeautyCenter=1`, params) };
export const updatebeautyCenter = (params) => { return req("post", `${url}/posts?updatebeautyCenter=1`, params) };
export const updateMachineVersion = (params) => { return req("post", `${url}/posts?updateMachineVersion=1`, params) };
export const getAddress = (params) => { return req("post", `${url}/posts?getAddress=1`, params) };
export const saveMachine = (params) => { return req("post", `${url}/posts?saveMachine=1`, params) };

// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", `${url}/posts?saveData=1`, params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.post(`${url}/posts?saveData=1`,params).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", `${url}/posts?modifyPwd=1`, params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get(`${url}/posts/User/lock?userId=` + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get(`${url}/posts/UserDept/tree/` + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", `${url}/posts/UserDept/save`, params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get(`${url}/posts/UserDept/deptTree/` + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", `${url}/posts?saveData=1`, params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", `${url}/posts/User/expireToken/` + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", `${url}/posts/User/flashCache/` + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", `${url}/posts/Module/list`) };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get(`${url}/posts/Module/get/` + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", `${url}/posts/Module/nodes`, params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", `${url}/posts/Module/save`, params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete(`${url}/posts/Module/delete?ids=` + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", `${url}/posts?getData=1`, params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", `${url}/posts?saveData=1`, params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.post(`${url}/posts?deleteData=1`,params).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.post(`${url}/posts?getData=1`,params).then(res => res.data) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", `${url}/posts?saveRoleMenu=1`, params) };

/**
 * 设备管理
 **/
// 获取数据信息
export const dataList = (params) => { return req("post", `${url}/posts?getData=1`, params) };
// 获取美容中心
export const deptList = (params) => { return req("post", `${url}/posts?getData=1`, params) };
// 设备管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", `${url}/posts?saveData=1`, params) };
// 设备管理-禁用设备
export const deptDelete = (params) => { return axios.post(`${url}/posts?deleteData=1`,params).then(res => res.data) };

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", `${url}/posts/Variable/list`, params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", `${url}/posts/Variable/save`, params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete(`${url}/posts/Variable/delete?ids=` + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", `${url}/posts/Permission/list`, params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", `${url}/posts/Permission/save`, params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete(`${url}/posts/Permission/delete?ids=` + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get(`${url}/posts/Role/dropDown/all?&token=` + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", `${url}/posts/RolePermission/save`, params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js